import { render, staticRenderFns } from "./NewWaterUsageChart.vue?vue&type=template&id=332dd9cd&scoped=true&"
import script from "./NewWaterUsageChart.vue?vue&type=script&lang=js&"
export * from "./NewWaterUsageChart.vue?vue&type=script&lang=js&"
import style0 from "./NewWaterUsageChart.vue?vue&type=style&index=0&id=332dd9cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332dd9cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
